



(function ($) {
    $(function () {

        const initModal = () => {
            var $sliderProductImage = $('.js-product-image-slider');

            if ($sliderProductImage.length) {
                let $sliderWrapper = $sliderProductImage.closest('.js-slider-wrapper');
                let sliderWidth = $sliderWrapper[0].offsetWidth;

                $sliderWrapper.css('width', sliderWidth);

                $sliderProductImage.slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    fade: true,
                    asNavFor: '.js-product-image-slider-nav'
                });

                $('.js-product-image-slider-nav').slick({
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    asNavFor: '.js-product-image-slider',
                    dots: false,
                    centerMode: true,
                    focusOnSelect: true
                });
            }
        }
        const initPrint = () => {
            $('body').on('click', '.js-print', function (e) {
                e.preventDefault();
                let $this = $(this);
                let printAreaId = '#print-area-' + $this.data('print');
                let printHtml = $(printAreaId).html();
                let headHtml = $('head').html();

                let s = window.open("", "Print-Window", "width=1000, height=800");
                s.document.open();
                s.document.write("<html><head>" + headHtml + '</head><body onload="window.print()"><div class="individual-product"><div class="detailed-specifications">' + printHtml + "</div></div></body></html>");
                s.document.close();
                setTimeout(function () {
                    s.close()
                }, 1e3);
            });
        }

        const init = () => {
            console.log("parts-------------------js");
            initModal();
            initPrint();
        }

        init();
    });
})(jQuery, window, document);
